<template>
  <div style="display: inline;">
    <!-- 搜索框插槽 -->
    <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
      <el-form-item class="noborder" :label="$t('jianyanbiaozhunmingcheng')">
        <el-input disabled v-model="$attrs.details.name"></el-input>
      </el-form-item>
      <el-form-item :label="$t('jianyanleixing')">
        <span v-if="$attrs.details.type == 1">{{ $t('shoujian') }}</span>
        <span v-if="$attrs.details.type == 2">{{ $t('choujian') }}</span>
        <span v-if="$attrs.details.type == 3">{{ $t('mojian') }}</span>
        <span v-if="$attrs.details.type == 4">{{ $t('chengpinjian') }}</span>
      </el-form-item>
      <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
        <yi_cross_select disabled :selectTitle="'code,name'" multiple :component="'web_base_matter_list'"
          :ids.sync="$attrs.details.materialId">
        </yi_cross_select>
      </el-form-item>
      <el-form-item class="noborder" :label="$t('jianyanbiaozhunbanben')">
        <el-input disabled v-model="$attrs.details.version"></el-input>
      </el-form-item>
      <el-form-item>
        <yi_curd_expand_button></yi_curd_expand_button>
      </el-form-item>
    </el-form>

    <el-tabs v-model="activeName" type="card">
      <!-- 物料检验标准tab -->
      <el-tab-pane :label="$t('wuliaojianyanbiaozhun')" name="materialInspectionStandardItem"></el-tab-pane>
      <!-- 分类检验标准tab -->
      <el-tab-pane :label="$t('fenleijianyanbiaozhun')" name="classificationInspectionStandards"></el-tab-pane>
    </el-tabs>
    <div class="dialog-scroller">
      <details_item v-if="activeName === 'materialInspectionStandardItem'" :details="$attrs.details"></details_item>
      <classification_standards_item v-if="activeName === 'classificationInspectionStandards'" :details="$attrs.details"></classification_standards_item>
    </div>
  </div>
</template>

<script type="text/javascript">
import details_item from "@@/pages/web/quality_management/inspection_standard/details_item";
import classification_standards_item from "@@/pages/web/quality_management/inspection_standard/classification_standards_item";

export default {
  name: 'web_quality_management_inspection_standard_details_item',
  components: {
    details_item,
    classification_standards_item
  },
  data() {
    return {
      activeName: 'materialInspectionStandardItem',
      show: false,
      typeList: [],
    };
  },
  created() {
    setTimeout(() => {}, 300);
  },
  methods: {},
};
</script>
